import { useSetState } from '@/shared/lib/customHooks';
import { EMITTER_CONSTANTS } from '@/shared/config';
import { auth, emitter } from '@/shared/lib';
import { useEffect } from 'react';

/**
 * Controls the SSO login banner shown above the app body. Seeds visibility from the persisted auth flag; an effect adds the have-banner-SSO class to scrollable rows while visible and strips it plus the marketing-banner and login-banner classes once hidden, and onClickClose persists the dismissal, emits the visibility event and hides the banner.
 *
 * @returns The banner visibility state and its close handler.
 */
export const useLoginByBanner = () => {
  const [state, setState] = useSetState({
    isShowLoginByBanner: auth.isShowLoginByBanner(),
  });

  useEffect(() => {
    const rowEls = document.getElementsByClassName('flexible-scroll');
    const rowEls2 = document.getElementsByClassName('--show-marketing-banner');
    const rowEls3 = document.getElementsByClassName('app-body');
    if (state.isShowLoginByBanner) {
      if (rowEls.length > 0) {
        for (let i = 0; i < rowEls.length; i += 1) {
          rowEls[i].classList.add('--have-banner-SSO');
        }
      }
    } else {
      if (rowEls.length > 0) {
        for (let i = 0; i < rowEls.length; i += 1) {
          rowEls[i].classList.remove('--have-banner-SSO');
        }
      }
      if (rowEls2.length > 0) {
        for (let i = 0; i < rowEls2.length; i += 1) {
          rowEls2[i].classList.remove('--show-marketing-banner');
        }
      }
      if (rowEls3.length > 0) {
        for (let i = 0; i < rowEls3.length; i += 1) {
          rowEls3[i].classList.remove('has-login-banner');
        }
      }
    }
  }, [state.isShowLoginByBanner]);

  /**
   * Dismisses the SSO login banner for the session. Persists the flag through auth.setIsShowLoginByBanner, emits the login-banner visibility event with false so other views react, then sets local state to hidden.
   *
   * @returns Nothing.
   */
  const onClickClose = () => {
    auth.setIsShowLoginByBanner(false);
    emitter.emit(EMITTER_CONSTANTS.IS_SHOW_LOGIN_BY_BANNER, {
      isShowLoginByBanner: false,
    });
    setState({ isShowLoginByBanner: false });
  };

  return {
    state,
    onClickClose,
  };
};
